import moment from 'moment'

const FTUE_EMPLOYEE_MANAGEMENT_KEY = '__ftue_employee_management_read'
const FTUE_SALES_TYPE_REPORTS_KEY = '__ftue_sales_type_reports'
const FTUE_SALES_TYPE_LIBRARY_KEY = '__ftue_sales_type_library'
const FTUE_PROMO_LIBRARY_KEY = '__ftue_promo_library'
const FTUE_TABLE_MANAGEMENT_KEY = '__ftue_table_management'

export function hideEmployeeManagement () {
  // set expires cookie to 1000 years from now
  // means never expire
  Cookies.set(FTUE_EMPLOYEE_MANAGEMENT_KEY, true, {expires: 1000 * 365})
}

export function shouldShowEmployeeManagement () {
  // remove FTUE regardless its condition after 1 january 2018
  const january2018 = moment('20180101')
  if (january2018.diff(moment(), 'days') < 0) {
    // cleanup cookie
    Cookies.remove(FTUE_EMPLOYEE_MANAGEMENT_KEY)
    return false
  } else {
    const cookie = Cookies.get(FTUE_EMPLOYEE_MANAGEMENT_KEY)
    return !cookie
  }
}

export function hideSalesTypeReports () {
  // set expires cookie to 1000 years from now
  // means never expire
  Cookies.set(FTUE_SALES_TYPE_REPORTS_KEY, true, {expires: 1000 * 365})
}

export function shouldShowSalesTypeReports () {
  const march2018 = moment('20180301')
  if (march2018.diff(moment(), 'days') < 0) {
    // cleanup cookie
    Cookies.remove(FTUE_SALES_TYPE_REPORTS_KEY)
    return false
  } else {
    const cookie = Cookies.get(FTUE_SALES_TYPE_REPORTS_KEY)
    return !cookie
  }
}

export function hideSalesTypeLibrary () {
  // set expires cookie to 1000 years from now
  // means never expire
  Cookies.set(FTUE_SALES_TYPE_LIBRARY_KEY, true, {expires: 1000 * 365})
}

export function shouldShowSalesTypeLibrary () {
  const march2018 = moment('20180301')
  if (march2018.diff(moment(), 'days') < 0) {
    // cleanup cookie
    Cookies.remove(FTUE_SALES_TYPE_LIBRARY_KEY)
    return false
  } else {
    const cookie = Cookies.get(FTUE_SALES_TYPE_LIBRARY_KEY)
    return !cookie
  }
}

export function hidePromoLibrary () {
  // set expires cookie to 1000 years from now
  // means never expire
  Cookies.set(FTUE_PROMO_LIBRARY_KEY, true, { expires: 1000 * 365 })
}

export function shouldShowPromoLibrary () {
  const march2018 = moment('20180301')
  if (march2018.diff(moment(), 'days') < 0) {
    // cleanup cookie
    Cookies.remove(FTUE_PROMO_LIBRARY_KEY)
    return false
  } else {
    const cookie = Cookies.get(FTUE_PROMO_LIBRARY_KEY)
    return !cookie
  }
}

export function hideTableManagement () {
  Cookies.set(FTUE_TABLE_MANAGEMENT_KEY, true, { expires: 1000 * 365 })
}

export function shouldShowTableManagement () {
  const apr2018 = moment('20180401')
  if (apr2018.diff(moment(), 'days') < 0) {
    Cookies.remove(FTUE_TABLE_MANAGEMENT_KEY)
    return false
  } else {
    const cookie = Cookies.get(FTUE_TABLE_MANAGEMENT_KEY)
    return !cookie
  }
}



// WEBPACK FOOTER //
// ./app/utils/ftue.js